<template>
  <div @click="clickImageItem" :style="{'border':showPreview ? '1px solid #ffffff' : ''}" class="imageItem">
<!--    旧版hover蓝色边框-->
<!--    <div :style="{'background':showPreview ? 'rgba(41, 128, 227, 0.5)' : null}" class="imageItem-border"></div>-->

    <div :style="{'background-image':'url(' + info.thumb + ')'}" style="position:relative;width:100%;height:100%;border-radius:5px;background-size:cover;background-position: center;cursor:pointer;">
      <p class="imageItem-title" style="">{{info.title}}</p>
<!--      <div style="position:absolute;top:0;right:0;width:35px;height:35px;background:rgba(255,255,255,0.6);text-align:center;">-->
<!--        <p :style="{'color':showPreview ? '#2980E3' : '#000000'}" style="font-weight:bold;font-size:12px;line-height:35px;">{{info.materialNumber}}</p>-->
<!--      </div>-->

      <!--停用标识-->
      <div v-if="info.status === 5" style="position:absolute;top:0;left:0;width:60px;height:35px;background:#178FFF;border-radius:6px 0 0 0;font-size:12px;color:#ffffff;text-align:center;">
        <p style="line-height:35px;">已停用</p>
      </div>

    </div>


  </div>

</template>

<script>
export default {
  name: "ImageItem",
  props:["info","showPreview"],
  methods:{
    clickImageItem(){
      if(this.info.status === 5){
        //停用
        this.$emit("showFolderStopDialog",this.info.mainId)
      }
      else{
        //正常
        this.$emit("showImagePreview",this.info.mainId)
      }

    }


  }
}
</script>

<style scoped>
.imageItem{
  position:relative;
  width:145px;
  height:145px;
  border:1px solid #a6a6a6;
  border-radius:6px;
}
.imageItem:hover{
  border:1px solid #ffffff;
}

/*!**旧版hover蓝色边框**!*/
/*.imageItem-border{*/
/*  position:absolute;*/
/*  top:-6px;*/
/*  left:-6px;*/
/*  width:160px;*/
/*  height:160px;*/
/*  border-radius:6px;*/
/*}*/
/*.imageItem:hover .imageItem-border{*/
/*  background:rgba(41, 128, 227, 0.2);*/
/*}*/

.imageItem-title{
  position:absolute;
  bottom:4px;
  left:9px;
  width:calc(100% - 18px);
  text-align:center;
  font-size:16px;
  color:#ffffff;
  font-weight:bold;
  text-shadow: 0px 0px 4px  rgba(0, 0, 0, 0.75);
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
</style>